import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { NgbModal, ModalDismissReasons } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: "appfolio-home-page",
  templateUrl: "./appfolio-home-page.component.html",
  styleUrls: ["./appfolio-home-page.component.css"],
})
export class AppFolioHomePage implements OnInit {
  constructor(private router: Router) {}

  vHostname: string;

  ngOnInit() {
    // localStorage.setItem("sessionId", null);
    // localStorage.setItem("appfolioFirstRegistrationDetails", null);
    // localStorage.setItem("appfolioSigUpCompany", null);
    this.vHostname = this.router.parseUrl(this.router.url).queryParams["vhost"];
  }

  goToRegistration() {
    this.router.navigate(["appfolio/registration"], {
      queryParams: {
        vhost: this.vHostname,
      },
    });
  }
}
